import store from "../../../store";
import choice_export from './choice_export.vue';

window.choice_export =  new Vue({
    store,
    el: 'div#choice_export',

    name : "choice_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        choice_export,
    }
});
